import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heart, ShoppingBag, Store, Handshake, X } from "lucide-react";

const RoleSelectorPopup = ({ onClose }) => {
  const navigate = useNavigate();

  const handleSelect = (role) => {
    // Store selection in sessionStorage so popup doesn't show again
    sessionStorage.setItem("edyt_role_selected", "true");
    
    if (role === "guest") {
      navigate("/pass");
    } else if (role === "vendor") {
      navigate("/vendor");
    } else if (role === "sponsor") {
      navigate("/sponsor");
    }
    
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] bg-[#FAF7F2] flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <Heart className="w-8 h-8 text-[#8B2332]" />
            <span className="font-heading text-3xl text-[#2D2D2D]">EDYT & BLOOM</span>
          </div>
          <h1 className="font-heading text-2xl md:text-3xl text-[#2D2D2D] mb-2">
            Willkommen zum <span className="text-[#8B2332] italic">Hijab & Halal</span> Pop-up
          </h1>
          <p className="text-[#6B6B6B]">
            Hamburg • 08.02.2026 • 11–19 Uhr
          </p>
        </div>

        {/* Selection Question */}
        <h2 className="font-heading text-xl md:text-2xl text-[#2D2D2D] text-center mb-8">
          Wie möchtest du dabei sein?
        </h2>

        {/* Role Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Guest */}
          <button
            onClick={() => handleSelect("guest")}
            className="group bg-white rounded-2xl p-6 border-2 border-[#EFEBE5] hover:border-[#8B2332] transition-all hover:shadow-lg text-left"
            data-testid="role-guest"
          >
            <div className="w-14 h-14 rounded-full bg-[#8B2332]/10 flex items-center justify-center mb-4 group-hover:bg-[#8B2332] transition-colors">
              <ShoppingBag className="w-7 h-7 text-[#8B2332] group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-heading text-xl text-[#2D2D2D] mb-2">
              Als Gast
            </h3>
            <p className="text-[#6B6B6B] text-sm">
              Ich möchte shoppen & das Event besuchen
            </p>
          </button>

          {/* Vendor */}
          <button
            onClick={() => handleSelect("vendor")}
            className="group bg-white rounded-2xl p-6 border-2 border-[#EFEBE5] hover:border-[#8B2332] transition-all hover:shadow-lg text-left"
            data-testid="role-vendor"
          >
            <div className="w-14 h-14 rounded-full bg-[#8B2332]/10 flex items-center justify-center mb-4 group-hover:bg-[#8B2332] transition-colors">
              <Store className="w-7 h-7 text-[#8B2332] group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-heading text-xl text-[#2D2D2D] mb-2">
              Als Brand
            </h3>
            <p className="text-[#6B6B6B] text-sm">
              Ich möchte mit einem Stand teilnehmen
            </p>
          </button>

          {/* Sponsor */}
          <button
            onClick={() => handleSelect("sponsor")}
            className="group bg-white rounded-2xl p-6 border-2 border-[#EFEBE5] hover:border-[#8B2332] transition-all hover:shadow-lg text-left"
            data-testid="role-sponsor"
          >
            <div className="w-14 h-14 rounded-full bg-[#8B2332]/10 flex items-center justify-center mb-4 group-hover:bg-[#8B2332] transition-colors">
              <Handshake className="w-7 h-7 text-[#8B2332] group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-heading text-xl text-[#2D2D2D] mb-2">
              Als Sponsor
            </h3>
            <p className="text-[#6B6B6B] text-sm">
              Ich möchte das Event sponsern
            </p>
          </button>
        </div>

        {/* Footer */}
        <p className="text-center text-[#6B6B6B] text-sm mt-8">
          Grand Palais • Osterrade 20 • 21031 Hamburg
        </p>
      </div>
    </div>
  );
};

export default RoleSelectorPopup;
